export const getSeconds = (hmsString: string) => {
    return hmsString.split(':').reduce(
        // @ts-ignore
        (acc,time) => (60 * acc) + +time
    );
}